var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "gs1-alert",
    {
      attrs: {
        alertClass: "warning",
        iconClass: "fa fa-exclamation-triangle color-orange"
      }
    },
    [
      _c("p", [_vm._v(_vm._s(_vm.$t("title")))]),
      _vm._v(" "),
      _c(
        "ul",
        { staticStyle: { "margin-top": "10px" } },
        _vm._l(_vm.ids, function(id) {
          return _c("li", { key: id }, [_vm._v(_vm._s(id))])
        })
      ),
      _vm._v(" "),
      _c(
        "i18n",
        { staticClass: "small", attrs: { path: "message", tag: "p" } },
        [
          _c("router-link", { attrs: { to: { name: "Bulk" } } }, [
            _vm._v(_vm._s(_vm.$t("redo")))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0575082e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0575082e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/alerts/Gs1AlertSearchTermErrors.vue
// module id = null
// module chunks = 